// table-expand.vue
<style scoped>
.expand-row {
  margin-bottom: 16px;
  margin-left: 40px;
}
.expand-key {
  margin-left: 16px;
  margin-right: 16px;
  font-weight: bold;
}
.expand-value {
  margin-right: 16px;
}

</style>
<template>
  <Collapse simple style="text-align: left;">
    <Panel name="1">
      地址信息
      <div slot="content">
        <Row class="expand-row">
          <Col span="20">
            <span class="expand-key">地址信息：</span>
            <span class="expand-value">{{ row.completeAddress }}</span>
          </Col>
        </Row>
      </div>
    </Panel>
    <Panel name="1">
      用户信息
      <div slot="content">
        <Row class="expand-row">
          <Col span="12">
            <span class="expand-key">用户姓名：</span>
            <span class="expand-value">{{ row.customerName }}</span>
          </Col>
          <Col span="12">
            <span class="expand-key">身份证号：</span>
            <span class="expand-value">{{ row.customerIdcard }}</span>
          </Col>
        </Row>
        <Row class="expand-row">
          <Col span="12">
            <span class="expand-key">联系电话：</span>
            <span class="expand-value">{{ row.cutomerPhone }}</span>
          </Col>
          <Col span="12">
            <span class="expand-key">表底数：</span>
            <span class="expand-value">{{ row.meterBaseNumber }}</span>
          </Col>
        </Row>
        <Row class="expand-row">
          <Col span="12">
            <span class="expand-key">用户备注：</span>
            <span class="expand-value">{{ row.customerRemark }}</span>
          </Col>
        </Row>
      </div>
    </Panel>
    <Panel name="1">
      表具详细信息
      <div slot="content">
        <Row class="expand-row">
          <Col span="12">
            <span class="expand-key">通讯方式：</span>
            <span class="expand-value">{{ row.meterCommunicationMode }}</span>
          </Col>
          <Col span="12">
            <span class="expand-key">设备串号：</span>
            <span
              class="expand-value"
            >{{ row.meterSerialNumber == "" ? '无' : row.meterSerialNumber}}</span>
          </Col>
        </Row>
        <Row class="expand-row">
          <Col span="12">
            <span class="expand-key">设备状态:</span>
            <span
              class="expand-value"
            >{{ row.meterUsageState == 0 ? "待开户" : (row.meterUsageState == 10 ? "待安检" :(row.meterUsageState == 20 ? "正常使用":(row.meterUsageState == -100 ? "废弃":"异常"))) }}</span>
          </Col>

          <Col span="12">
            <span class="expand-key">注册编号：</span>
            <span class="expand-value">{{ row.meterRegisterKey }}</span>
          </Col>
        </Row>
        <Row class="expand-row">
          <Col span="12">
            <span class="expand-key">用气类型:</span>
            <span
              class="expand-value"
            >{{ row.meterGasTypeName}}</span>
          </Col>
        </Row>
      </div>
    </Panel>
    <Panel name="1">
      设备类型信息
      <div slot="content">
        <Row class="expand-row">
          <Col span="12">
            <span class="expand-key">设备类型：</span>
            <span class="expand-value">{{ row.meterTypeName }}</span>
          </Col>
          <Col span="12">
            <span class="expand-key">计费方式：</span>
            <span class="expand-value">{{ row.meterTypePayType }}</span>
          </Col>
        </Row>
        <Row class="expand-row">
          <Col span="12">
            <span class="expand-key">类型描述:</span>
            <span class="expand-value">{{ row.meterTypeRemark }}</span>
          </Col>
        </Row>
      </div>
    </Panel>
  </Collapse>
</template>
<script>
export default {
  props: {
    row: Object
  },
  mounted() {
    console.log(this.row);
    let num = this.row.meterBaseNumber;
    num += '';  
    num = num.replace(/[^0-9|\.]/g, ''); //清除字符串中的非数字非.字符  
    if(/^0+/) //清除字符串开头的0  
        num = num.replace(/^0+/, '');  
    if(!/\./.test(num)) //为整数字符串在末尾添加.00  
        num += '.000';  
    if(/^\./.test(num)) //字符以.开头时,在开头添加0  
        num = '0' + num;  
    num += '000';        //在字符串末尾补零  
    num = num.match(/\d+\.\d{3}/)[0];
    this.row.meterBaseNumber = num;
  }
};
</script>